// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32d92","content":"styles_content__VookJ"};